import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-DPI流量*/
import React from 'react';
import './index.scss';
import * as echarts from 'echarts';
import moment from "moment";
import { withRouter } from 'react-router-dom';
import { pieChartColor } from "../../../utils/commonConsts";
import { parse } from '../../../utils/commonUtilFunc';
import { injectIntl } from 'react-intl';
var Option = _Select.Option;
var RangePicker = _DatePicker.RangePicker;
var CI0303 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0303, _React$Component);
  function CI0303(props) {
    var _this;
    _classCallCheck(this, CI0303);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0303).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      _this.setState({
        name: e.target.value
      }, function () {
        if (!_this.state.name) {
          _this.get_steps_beta();
        }
      });
    }); //获取设备流量排行
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_steps_beta", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_steps_beta",
        payload: {
          start_tm: _this.state.start_tm,
          end_tm: _this.state.end_tm,
          companyid: _this.ifCompany ? _this.search.id : sessionStorage.getItem("companyId"),
          company_id: _this.ifCompany ? _this.search.id : sessionStorage.getItem("companyId"),
          tunnel_dir: _this.state.tunnel_dir,
          top: _this.state.top,
          name: _this.state.name
        }
      });
    }); //选择隧道内或隧道外流量
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTunnelDir", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        tunnel_dir: value || "2"
      }, function () {
        vm.get_steps_beta();
      });
    }); //选择时间间隔
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeInterval", function (type) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      var start_tm = "";
      var end_tm = moment().format("YYYY-MM-DD HH:mm:ss");
      switch (type) {
        case "0":
          start_tm = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm = moment().subtract(6, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm = moment().subtract(24, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm = moment().subtract(7, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          start_tm = moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
      }
      _this.setState({
        start_tm: start_tm,
        end_tm: end_tm
      }, function () {
        vm.get_steps_beta();
      });
    }); //选择数据条数
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        top: value || "0"
      }, function () {
        vm.get_steps_beta();
      });
    }); //绘制图表
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (el) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisTick: {
            show: false
          },
          name: "MB",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          axisLabel: {
            interval: 0,
            formatter: function formatter(params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 8;
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p === rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
            align: "left",
            margin: 100
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        series: [{
          name: "flow",
          type: 'bar',
          data: _this.props.ci0303Info.steps_beta_flow,
          itemStyle: {
            normal: {
              color: function color(params) {
                return pieChartColor[params.dataIndex % pieChartColor.length];
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          barCategoryGap: "60%",
          barMinHeight: "10",
          barMaxWidth: 32
        }],
        color: ["red", "yellow"]
      };
      el.setOption(option);
      el.resize({
        width: _this.state.chartWidth,
        height: 590
      });
    }); //在窗口拉伸时自适应
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResize", function () {
      _this.setState({
        chartWidth: document.body.clientWidth > 1366 ? document.body.clientWidth - 320 : 1366 - 320
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current.diff(_this.state.start_tm, 'days') < -5 || current.diff(_this.state.start_tm, 'days') > 6;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangeChange", function (moment) {
      if (moment.length === 1) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss")
        });
      } else if (moment.length === 2) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss"),
          end_tm: moment[1].format("YYYY-MM-DD HH:mm:ss")
        }, function () {
          _this.get_steps_beta();
        });
      }
    });
    _this.state = {
      chartWidth: document.body.clientWidth > 1366 ? document.body.clientWidth - 320 : 1366 - 320,
      tunnel_dir: "2",
      start_tm: moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
      end_tm: moment().format("YYYY-MM-DD HH:mm:ss"),
      top: 5,
      name: ""
    };
    _this.search = parse(_this.props.location.search);
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(CI0303, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vm = this;
      this.get_steps_beta();
      this.element = echarts.init(document.getElementById('device-flow-container'));
      this.element.on('click', function (params) {
        var tunnel_dir;
        switch (vm.state.tunnel_dir) {
          case "2":
            tunnel_dir = "whole";
            break;
          case "1":
            tunnel_dir = "Tunnel flow";
            break;
          case "0":
            tunnel_dir = "Tunnel external flow";
            break;
          default:
            tunnel_dir = "";
            break;
        }
        vm.props.history.push("/main/ci0303/ci0304?start_tm=" + vm.state.start_tm + "&end_tm=" + vm.state.end_tm + "&tunnel_dir=" + tunnel_dir + "&tunnel_dir_id=" + vm.state.tunnel_dir + "&device_name=" + params.data[3] + "&sn=" + params.data[2] + "&flow=" + params.data[0] + "&id=" + vm.search.id);
      });
      this.renderChart(this.element);
      window.addEventListener('resize', this.onWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChart(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      var dateFormat = 'YYYY-MM-DD HH:mm:ss';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select a time interval",
        style: {
          width: 200,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectTimeInterval,
        defaultValue: "0"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "Last 30 minutes"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "Last 6 hours"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "Last Day"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "Last week")), /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 350,
          marginRight: 8
        },
        showTime: true,
        value: [moment(this.state.start_tm, dateFormat), moment(this.state.end_tm, dateFormat)],
        disabledDate: this.disabledDate,
        onCalendarChange: this.handleRangeChange
      }), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 200,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_steps_beta
      }, "search")), /*#__PURE__*/React.createElement("div", {
        id: "device-flow-container",
        style: {
          height: 590,
          width: this.state.tableWidth
        }
      })));
    }
  }]);
  return CI0303;
}(React.Component);
export default withRouter(injectIntl(CI0303));